module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container row",
    attrs: {
      "id": "slider"
    }
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    },
    on: {
      "click": _vm.onclick
    }
  }, [_vm._l((_vm.gifs), function(g) {
    return _c('swiper-slide', {
      key: g.id,
      staticClass: "swiper-lazy",
      style: ({
        'background-image': 'url(' + g.gif + ')'
      })
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('div', {
      staticClass: "title-bg"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(g.title))])]), _vm._v(" "), _c('div', {
      staticClass: "note-bg"
    }, [_c('p', {
      staticClass: "note"
    }, [_vm._v(_vm._s(g.note))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-white",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fada0baa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
// module id = 91
// module chunks = 0